import HeaderEffect, { useAccentReducer } from "./components/HeaderEffect"
import FBOHeader from "./components/FBOHeader"
import { Environment, View } from "@react-three/drei"


export default function Header() {
    const { accents, accent, click, registerImpulse } = useAccentReducer()
    return (
        <View onClick={click} className="view header">
            <FBOHeader size={[20, 7]} radius={0.5} position={[0, 0, 0]}>
                <HeaderEffect accents={accents} accent={accent} click={click} registerImpulse={registerImpulse} />
            </FBOHeader>
        </View>
    )
}